import { Stack } from '@mantine/core';
import DocumentPane from '../../Molecules/Event/Documents/DocumentPane';
import ContractPane from '../../Molecules/Event/Contracts/ContractPane';
import QuestionnairePane from '../../Molecules/Event/Questionnaires/QuestionnairePane';
import EventUploads from '../../Molecules/Event/EventUploads';
import MessageFilesPane from '../../Molecules/Event/MessageFilesPane';
import { useBookitupScope } from '../../Service/Context/BookitupSubscriptionContext';

const EventDocuments = () => {
  const { isScopeSelected: hasDocumentsScope } = useBookitupScope('DOCUMENTS');
  const { isScopeSelected: hasContractsScope } = useBookitupScope('CONTRACTS');
  const { isScopeSelected: hasQuestionnairesScope } = useBookitupScope('QUESTIONNAIRES');
  const { isScopeSelected: hasEventUploadsScope } = useBookitupScope('EVENT_UPLOADS');

  return (
    <Stack>
      {hasDocumentsScope && <DocumentPane />}
      {hasContractsScope && <ContractPane />}
      {hasQuestionnairesScope && <QuestionnairePane />}
      {hasEventUploadsScope && (
        <>
          <EventUploads />
          <MessageFilesPane />
        </>
      )}
    </Stack>
  );
};

export default EventDocuments;
